module.exports = __webpack_public_path__ + "f148de44b44457206309f4da82ec4cd5.png";